import { useSelector, useDispatch } from 'react-redux';
import { setSubContext } from 'modules/common/actions';
import { CategoryItem, CategoryItemWrapper, Wrapper } from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { subContext, categories } = useSelector(state => ({
    subContext: state.common.subContext,
    categories: state.masterServices.categories.details,
  }));
  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleCategoryItemClick = key => {
    dispatch(setSubContext(key));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      {categories?.length > 0 &&
        categories.map(categoryItem => (
          <CategoryItemWrapper
            key={categoryItem.categoryKey}
            selected={subContext === categoryItem.categoryKey}
            onClick={() => handleCategoryItemClick(categoryItem.categoryKey)}
          >
            <CategoryItem>{categoryItem.categoryNameEn}</CategoryItem>
          </CategoryItemWrapper>
        ))}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
